module.exports = "https://coursera_assets.s3.amazonaws.com/images/f9803efcc28baabf1aca9bde7857b052.png";